import React, { useState, useEffect } from "react";
import { Layout, Menu, Image, Tooltip } from "antd";
import { 
  AppstoreOutlined, 
  SettingFilled, 
  DashboardOutlined,
  HomeOutlined,
  BarChartOutlined,
  ControlOutlined
} from "@ant-design/icons";
import { Link } from "react-router-dom";

const { Sider } = Layout;

const Sidebar = ({ collapsed }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const menuItems = [
    {
      key: "0",
      icon: <BarChartOutlined className="text-lg" />,
      title: "ระดับบริษัท",
      link: "/dashboard",
      disabled: localStorage.getItem("accountType") === "0",
    },
    {
      key: "1",
      icon: <HomeOutlined className="text-lg" />,
      title: "สรุปข้อมูล",
      link: "/",
    },
    {
      key: "sub1",
      icon: <ControlOutlined className="text-lg" />,
      title: "ตั้งค่าระบบ",
      disabled: localStorage.getItem("accountType") === "0",
      items: [
        {
          key: "3",
          title: "ลงทะเบียนหน่วยงาน",
          link: "/system/sites",
          pages: "all",
        },
        {
          key: "4",
          title: "ลงทะเบียนอุปกรณ์",
          link: "/system/devices",
          pages: "vms",
        },
        {
          key: "44",
          title: "สร้างการแจ้งเตือน",
          link: "/system/device-noti",
          pages: "vms",
        },
        {
          key: "55",
          title: "สร้างการแจ้งเตือน",
          link: "/system/device-noti",
          pages: "patrol",
        },
        {
          key: "4",
          title: "ลงทะเบียนอุปกรณ์",
          link: "/system/devices",
          pages: "patrol",
        },
        {
          key: "5",
          title: "ตั้งค่าโปรแกรม",
          link: "/system/program",
          pages: "vms",
        },
        {
          key: "5",
          title: "ตั้งค่าโปรแกรม",
          link: "/system/program",
          pages: "patrol",
        },
        {
          key: "6",
          title: "ตั้งค่ารอบการตรวจ",
          link: "/system/cycle",
          pages: "patrol",
        },
        {
          key: "7",
          title: "ตั้งค่าบริษัทผู้มาติดต่อ",
          link: "/system/subcontract",
          pages: "vms",
        },
        {
          key: "8",
          title: "ระบบจัดการบัตรผู้มาติดต่อ",
          link: "/system/card",
          pages: "vms",
        },
        {
          key: "9",
          title: "ตั้งค่าแจ้งเตือน",
          link: "/system/notify",
          pages: "vms",
        },
        {
          key: "10",
          title: "ตั้งค่าแจ้งเตือน",
          link: "/system/notify",
          pages: "patrol",
        },
      ],
    },
  ];

  const renderMenuItem = (item) => {
    const menuContent = (
      <Menu.Item 
        key={item.key} 
        icon={item.icon}
        disabled={item.disabled}
        className="transition-all duration-200 hover:bg-blue-600 hover:bg-opacity-20 rounded-lg mx-1 md:mx-2 my-1"
        style={{
          height: isMobile ? '44px' : '48px',
          lineHeight: isMobile ? '44px' : '48px',
          marginBottom: '4px',
          fontSize: isMobile ? '14px' : '16px',
        }}
      >
        {item.disabled ? (
          <span 
            className="flex items-center font-medium"
            style={{ textDecoration: 'none', cursor: 'not-allowed', opacity: 0.5 }}
          >
            {item.title}
          </span>
        ) : (
          <Link 
            to={item.link} 
            className="flex items-center font-medium"
            style={{ textDecoration: 'none' }}
          >
            {item.title}
          </Link>
        )}
      </Menu.Item>
    );

    return collapsed ? (
      <Tooltip 
        title={item.title} 
        placement="right" 
        key={item.key}
      >
        {menuContent}
      </Tooltip>
    ) : (
      menuContent
    );
  };

  const renderSubMenu = (item) => {
    const subMenuContent = (
      <Menu.SubMenu
        disabled={item.disabled}
        key={item.key}
        icon={item.icon}
        title={item.title}
        className="transition-all duration-200"
        style={{
          marginBottom: '4px',
        }}
      >
        {item.items.map((subItem) => (
          <React.Fragment key={subItem.key}>
            {subItem?.pages === "all" && (
              <Menu.Item 
                key={subItem.key} 
                icon={subItem.icon}
                className="transition-all duration-200 hover:bg-blue-500 hover:bg-opacity-10 rounded-lg mx-1 md:mx-2 my-1"
                style={{
                  height: isMobile ? '36px' : '40px',
                  lineHeight: isMobile ? '36px' : '40px',
                  fontSize: isMobile ? '13px' : '14px',
                }}
              >
                <Link to={subItem.link} className="font-medium">
                  {subItem.title}
                </Link>
              </Menu.Item>
            )}
            {subItem?.pages === "vms" &&
              localStorage.getItem("system") === "1" && (
                <Menu.Item 
                  key={subItem.key} 
                  icon={subItem.icon}
                  className="transition-all duration-200 hover:bg-blue-500 hover:bg-opacity-10 rounded-lg mx-1 md:mx-2 my-1"
                  style={{
                    height: isMobile ? '36px' : '40px',
                    lineHeight: isMobile ? '36px' : '40px',
                    fontSize: isMobile ? '13px' : '14px',
                  }}
                >
                  <Link to={subItem.link} className="font-medium">
                    {subItem.title}
                  </Link>
                </Menu.Item>
              )}
            {subItem?.pages === "patrol" &&
              localStorage.getItem("system") === "2" && (
                <Menu.Item 
                  key={subItem.key} 
                  icon={subItem.icon}
                  className="transition-all duration-200 hover:bg-blue-500 hover:bg-opacity-10 rounded-lg mx-1 md:mx-2 my-1"
                  style={{
                    height: isMobile ? '36px' : '40px',
                    lineHeight: isMobile ? '36px' : '40px',
                    fontSize: isMobile ? '13px' : '14px',
                  }}
                >
                  <Link to={subItem.link} className="font-medium">
                    {subItem.title}
                  </Link>
                </Menu.Item>
              )}
          </React.Fragment>
        ))}
      </Menu.SubMenu>
    );

    return collapsed ? (
      <Tooltip 
        title={item.title} 
        placement="right" 
        key={item.key}
      >
        {subMenuContent}
      </Tooltip>
    ) : (
      subMenuContent
    );
  };

  return (
    <>
      {/* Mobile overlay */}
      {isMobile && !collapsed && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => {
            // This would need to be passed as a prop to close the sidebar
            window.dispatchEvent(new CustomEvent('closeSidebar'));
          }}
          style={{ zIndex: 999 }}
        />
      )}
      
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed} 
        collapsedWidth={isMobile ? 0 : 60}
        width={isMobile ? 240 : 280}
        className="slide-in-left shadow-lg"
        style={{
          background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 50%, #1d4ed8 100%)',
          borderRight: '1px solid rgba(255, 255, 255, 0.1)',
          position: isMobile ? 'fixed' : 'relative',
          height: isMobile ? '100vh' : 'auto',
          zIndex: isMobile ? 1000 : 'auto',
          left: isMobile && collapsed ? '-280px' : '0',
          transition: 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          top: isMobile ? 0 : 'auto',
          overflow: isMobile ? 'hidden auto' : 'visible',
        }}
      >
      {/* Logo Section */}
      <div className={`${isMobile ? 'p-3' : 'p-4'} text-center border-b border-white border-opacity-10`}>
        <Link to="/" className="flex items-center justify-center">
          {collapsed && !isMobile ? (
            <div className="w-10 h-10 bg-white bg-opacity-10 rounded-lg flex items-center justify-center">
              <Image 
                preview={false} 
                width={32} 
                height={32}
                src="/favicon.svg" 
                className="rounded-lg"
              />
            </div>
          ) : (
            <div className="flex items-center space-x-3">
              <div className={`${isMobile ? 'w-10 h-10' : 'w-12 h-12'} bg-white bg-opacity-10 rounded-lg flex items-center justify-center`}>
                <Image 
                  preview={false} 
                  width={isMobile ? 32 : 36} 
                  height={isMobile ? 32 : 36}
                  src="/favicon.svg" 
                  className="rounded-lg"
                />
              </div>
              <div className="text-white">
                <div className={`${isMobile ? 'text-base' : 'text-lg'} font-bold`}>ระบบติดตาม</div>
                <div className={`${isMobile ? 'text-xs' : 'text-xs'} opacity-75`}>Monitoring System</div>
              </div>
            </div>
          )}
        </Link>
      </div>

      {/* Menu Section */}
      <div className={`${isMobile ? 'px-1 py-3' : 'px-2 py-4'}`}>
        <Menu 
          theme="dark" 
          mode="inline" 
          defaultSelectedKeys={["1"]}
          className="border-0 bg-transparent"
          style={{
            background: 'transparent',
            border: 'none',
            fontSize: isMobile ? '14px' : '16px',
          }}
        >
          {menuItems.map((item) => {
            if (item.items) {
              return renderSubMenu(item);
            } else {
              return renderMenuItem(item);
            }
          })}
        </Menu>
      </div>
    </Sider>
    </>
  );
};

export default Sidebar;
